import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ToastData, ToastType } from '@ui';

@Component({
  selector: 'xten-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: ToastData) {}

  private readonly config: Record<ToastType, { icon: string; color: string }> =
    {
      success: { icon: 'check_circle', color: 'green' },
      error: { icon: 'cancel', color: 'red' },
      warning: { icon: 'warning', color: 'orange' },
      info: { icon: 'info', color: '#1976d2' },
    };

  private readonly defaultConfig = { icon: 'info', color: '#1976d2' };

  get icon(): string {
    return (
      this.config[this.data.type as ToastType]?.icon ?? this.defaultConfig.icon
    );
  }

  get color(): string {
    return (
      this.config[this.data.type as ToastType]?.color ??
      this.defaultConfig.color
    );
  }
}
